import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/EventsApi/" );
const basketStepInstance = new HttpService( "umbraco/api/BasketStep/" );

export const getInstance = ( instanceId, pricingScheduleId ) => instance.get( "GetInstance", { instanceId, pricingScheduleId } );

export const listBookings = ( orderHeaderId ) => instance.get( "ListBookings", { orderHeaderId } );

export const validateBookings = () => basketStepInstance.get( "ValidateBookings" );
